const API_URL = process.env.REACT_APP_API_URL;

const getAPI = (id) => ({
  CHARACTER: `${API_URL}/run/${id}/character`,
  EMPLOYEE: `${API_URL}/run/${id}/employee`,
  HOST: `${API_URL}/run/${id}/host`,
  LOG: `${API_URL}/run/${id}/log`,
  LOGIN: `${API_URL}/run/${id}/login`,
  PLOT: `${API_URL}/run/${id}/plot`,
  USER: `${API_URL}/run/${id}/user`,
  RUN: `${API_URL}/run`,
  UPLOAD: `${API_URL}/admin/sign-file`,
  RUN_COPY: `${API_URL}/admin/copy-run-data`,
});

/***********/
/** PLOTS **/
/***********/

export const getPlots = ({ runId }) => ({
  url: getAPI(runId).PLOT,
  method: "GET",
});

export const getPlot = ({ id, runId }) => ({
  url: `${getAPI(runId).PLOT}/${id}`,
  method: "GET",
});

export const postPlot = ({ runId }) => ({
  url: getAPI(runId).PLOT,
  method: "POST",
});

export const putPlot = ({ id, runId }) => ({
  url: `${getAPI(runId).PLOT}/${id}`,
  method: "PUT",
});

/****************/
/** CHARACTERS **/
/****************/

export const getCharacters = ({ runId }) => ({
  url: getAPI(runId).CHARACTER,
  method: "GET",
});

export const getCharacter = ({ id, runId }) => ({
  url: `${getAPI(runId).CHARACTER}/${id}`,
  method: "GET",
});

export const postCharacter = ({ runId }) => ({
  url: getAPI(runId).CHARACTER,
  method: "POST",
});

export const putCharacter = ({ id, runId }) => ({
  url: `${getAPI(runId).CHARACTER}/${id}`,
  method: "PUT",
});

/***********/
/** HOSTS **/
/***********/

export const getHosts = ({ runId }) => ({
  url: getAPI(runId).HOST,
  method: "GET",
});

export const getHost = ({ id, runId }) => ({
  url: `${getAPI(runId).HOST}/${id}`,
  method: "GET",
});

export const postHost = ({ runId }) => ({
  url: getAPI(runId).HOST,
  method: "POST",
});

export const putHost = ({ id, runId }) => ({
  url: `${getAPI(runId).HOST}/${id}`,
  method: "PUT",
});

/***************/
/** EMPLOYEES **/
/***************/

export const getEmployees = ({ runId }) => ({
  url: getAPI(runId).EMPLOYEE,
  method: "GET",
});

export const getEmployee = ({ id, runId }) => ({
  url: `${getAPI(runId).EMPLOYEE}/${id}`,
  method: "GET",
});

/**********/
/** LOGS **/
/**********/

export const getLog = ({ filter, runId }) => ({
  url: `${getAPI(runId).LOG}?${filter}`,
  method: "GET",
});

/**********/
/** USER **/
/**********/

export const postUser = ({ runId }) => ({
  url: getAPI(runId).USER,
  method: "POST",
});

export const putUser = ({ id, runId }) => ({
  url: `${getAPI(runId).USER}/${id}`,
  method: "PUT",
});

/**********/
/** RUNS **/
/**********/

export const getRuns = () => ({
  url: `${getAPI().RUN}`,
  method: "GET",
});

export const getRun = ({ id }) => ({
  url: `${getAPI().RUN}/${id}`,
  method: "GET",
});

export const postRun = () => ({
  url: getAPI().RUN,
  method: "POST",
});

export const postRunCopy = () => ({
  url: getAPI().RUN_COPY,
  method: "POST",
});

/***********/
/** LOGIN **/
/***********/

export const postLogin = ({ runId }) => ({
  url: getAPI(runId).LOGIN,
  method: "POST",
});

/************/
/** UPLOAD **/
/************/

export const postUpload = () => ({
  url: getAPI().UPLOAD,
  method: "POST",
});
